import * as yup from "yup";

const validation = () => {
  return yup.object().shape({});
};

export default validation;
